import ToastV2 from '@shared/components/base/BaseToast';
import i18n from '@shared/i18n/index';
import { StatusCode } from './statusCode';

const offlineFilterMsg = () => i18n.get('AppDetail_FilterOffline_Disabled');
const infiniteTalkPromptTooLongMsg = () => i18n.get('DigitalHuman_Exceeds length');

export const ATOMIC_POWER_UNSUPPORTED_CODE = 20001;

const CODE_TOAST: Record<number, () => string> = {
	[StatusCode.UnsupportedItem]: offlineFilterMsg,
	[StatusCode.InfiniteTalkPromptTooLong]: infiniteTalkPromptTooLongMsg,
};

const ATOMIC_POWER_CODE_TOAST: Record<number, () => string> = {
	[ATOMIC_POWER_UNSUPPORTED_CODE]: offlineFilterMsg,
};

export const isCodeToast = (code?: number) => code != null && code in CODE_TOAST;

export const isAtomicPowerCodeToast = (code?: number) =>
	code != null && code in ATOMIC_POWER_CODE_TOAST;

export const toastAtomicPowerCode = (code?: number) => {
	const getMsg = code != null && ATOMIC_POWER_CODE_TOAST[code];
	if (!getMsg) return false;
	ToastV2.error(getMsg());
	return true;
};

export const toastCode = (code?: number) => {
	const getMsg = code != null && CODE_TOAST[code];
	if (!getMsg) return false;
	ToastV2.error(getMsg());
	return true;
};

export const toastOfflineFilter = () => {
	ToastV2.error(offlineFilterMsg());
	return true;
};
